// noinspection JSVoidFunctionReturnValueUsed

jQuery(function ($) { // wait for document ready
    var headerHeight = $('.page-header').outerHeight();
    var adminBarHeight = 0;
    if ($('#wpadminbar').length) {
        headerHeight += $('#wpadminbar').outerHeight();
        adminBarHeight += $('#wpadminbar').outerHeight();
    }
    var controller = new ScrollMagic.Controller({});
    var scenes = [];
    var doit;
    window.onresize = function () {
        clearTimeout(doit);
        doit = setTimeout(scrollSetup, 100);
    };
    setupCharitableTrustsPage();
    var curSize = '';

    function setupCharitableTrustsPage(force = false) {
        var windowWidth = $(window).width();
        var newSize = 'desktop';
        if (windowWidth <= 767) {
            newSize = 'mobile';
        }
        if (curSize == newSize && !force)
            return true;

        curSize = newSize;
        resetScrollMagic();
        var cookieVal = read_cookie('notice-dismissed');
        if (curSize == 'mobile') {

        } else if (curSize == 'desktop') {
            var slides;
            if ($('.charitable-trusts-page').length) { // on either parent page or child page, set the animation for the cookie notice
                if (cookieVal != 'dismissed') {
                    scenes.push(new ScrollMagic.Scene({triggerElement: "#slide1"})
                        // trigger animation by adding a css class
                        .setClassToggle($('.cta-floating')[0], "visible")
                        .addTo(controller));
                } else {
                    delete_cookie('notice-dismissed');
                }
            }
            if ($('.work-for-me-page').length) { // child page
                console.log('child page');
                // pin slide 1 throughout slides 2 and 3, so the heading stays still while the first 3 messages with the
                // white backgrounds scroll in and fade out
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide1',
                        duration: "310%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide1', {pushFollowers: false})
                        //                         .addIndicators({name: 'Slide 1'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                // toggle the active class to fade the text with the white background to fade in/out for slide 1
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onEnter',
                        triggerElement: '#slide1',
                        duration: "185%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide1')[0], "active")
                        // .addIndicators({name: 'Slide 1 Class'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

                // hold slide 2 in place for a moment so the text sticks to the bottom of the screen for a second
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide2',
                        duration: "150%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide2', {pushFollowers: false})
                        // .addIndicators({name: 'Slide 2'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                // toggle the active class to fade the text with the white background to fade in/out for slide 2
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide2',
                        duration: "100%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide2')[0], "active")
                        // .addIndicators({name: 'Slide 2'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

                // hold slide 3 in place for a moment so the text sticks to the bottom of the screen for a second
                // use pushfollowers to make this one scroll up with the page when it's over
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3',
                        duration: "150%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide3', {pushFollowers: true})
                        // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                        .addTo(controller)
                );
                // toggle the active class to fade the text with the white background to fade in/out for slide 3
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide3',
                        duration: "300%",
                        offset: -1 * headerHeight
                    })
                        .setClassToggle($('#slide3')[0], "active")
                        // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                        .addTo(controller)
                );

                // pin slide 4 for a moment so it stays on the page briefly while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide4',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide4', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

                // pin slide 5 for a moment so it stays on the page briefly while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide5',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide5', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));


                // set up some animations for the text and boxes to slide in from the left and right
                var slideTextFromLeftTween = new TimelineMax().from($('#slide4').find('.titles')[0], 0.5, {
                    left: -500,
                    opacity: 0,
                    top: 0,
                    ease: Linear.easeInOut
                }).to($('#slide4').find('.titles')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                var slideBoxFromRightTween = new TimelineMax().from($('#slide4').find('.box')[0], 0.5, {
                    left: 500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide4').find('.box')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                // make the text slide in from the left when entering slide 4
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide4',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideTextFromLeftTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 4
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide4',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideBoxFromRightTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));


                // set up some animations for the text and boxes to slide in from the left and right
                var slideBoxFromLeftTween = new TimelineMax().from($('#slide5').find('.box')[0], 0.5, {
                    left: -500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide5').find('.box')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});
                var slideTextFromRightTween = new TimelineMax().from($('#slide5').find('.titles')[0], 0.5, {
                    left: 500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide5').find('.titles')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                // make the text slide in from the right when entering slide 5
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide5',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideTextFromRightTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the left when entering slide 5
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide5',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideBoxFromLeftTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                /*** START OF WATER MILL BACKGROUND **/

                    // this is the background which is visible during slides 6 - 8 (the water mill)
                    // slide background in
                var background = $('#background-2')[0];
                // add animations for the background to slide across and back as we scroll
                var backgroundSlideIn = TweenMax.to("#bg2-inner", 0.5, {
                    css: {'background-position-x': 0, opacity: 1, left: 0},
                    ease: Linear.easeInOut
                });
                var backgroundSlideAcross = TweenMax.to("#bg2-inner", 0.5, {
                    css: {
                        'background-position-x': '10vw', opacity: 1,
                        left: '10vw'
                    },
                    ease: Linear.easeInOut
                });
                var backgroundSlideBack = TweenMax.to("#bg2-inner", 0.5, {
                    css: {'background-position-x': 0, opacity: 1, left: 0},
                    ease: Linear.easeInOut
                });

                // set up the background to slide in when reaching the element with the background (top of slide 6)
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(backgroundSlideIn)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // slide 6 also has the text and box sliding in from the left and right
                $("#slide6").find('h2').css('left', '-25vw');
                $("#slide6").find('.box').css('left', '25vw');

                var slideTextFromLeftTween2 = new TimelineMax()
                    .from($("#slide6").find('h2')[0], 0.5, {
                        css: {'left': '-50vw', 'top': 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide6").find('h2')[0], 0.5, {
                        css: {'left': 0, 'top': 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                var slideBoxFromRightTween2 = new TimelineMax()
                    .from($("#slide6").find('.box')[0], 0.5, {
                        css: {'left': '50vw', 'top': 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide6").find('.box')[0], 0.5, {
                        css: {'left': 0, 'top': 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                // make the text slide in from the left when entering slide 6
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(slideTextFromLeftTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 6
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(slideBoxFromRightTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the background slide across when entering slide 7
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide7',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: '50%'
                })
                    .setTween(backgroundSlideAcross)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));


                // slide 7 is the same as slide 6, but with the text and boxes sliding in from the opposite sides
                $("#slide7").find('h2').css('left', '25vw');
                $("#slide7").find('.box').css('left', '-25vw');
                var slideTextFromRightTween2 = new TimelineMax()
                    .from($("#slide7").find('h2')[0], 0.5, {
                        css: {'left': '50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide7").find('h2')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                var slideBoxFromLeftTween2 = new TimelineMax()
                    .from($("#slide7").find('.box')[0], 0.5, {
                        css: {'left': '-50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide7").find('.box')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                // make the text slide in from the right when entering slide 7
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide7",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: '0'
                })
                    .setTween(slideTextFromRightTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the left when entering slide 7
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide7",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: '0'
                })
                    .setTween(slideBoxFromLeftTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the background slide back when entering slide 8
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide8',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: '50%'
                })
                    .setTween(backgroundSlideBack)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // slide 8 is the same as slide 6, with the text and boxes sliding in from the left and right
                $("#slide8").find('h2').css('left', '-25vw');
                $("#slide8").find('.box').css('left', '25vw');
                var slideTextFromLeftTween3 = new TimelineMax()
                    .from($("#slide8").find('h2')[0], 0.5, {
                        css: {'left': '-50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide8").find('h2')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                var slideBoxFromRightTween3 = new TimelineMax()
                    .from($("#slide8").find('.box')[0], 0.5, {
                        css: {'left': '50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide8").find('.box')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                // make the text slide in from the left when entering slide 8
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide8",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: '0'
                })
                    .setTween(slideTextFromLeftTween3)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 8
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide8",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: '0'
                })
                    .setTween(slideBoxFromRightTween3)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // this pins the background for slides 6 - 8 so it stays at the same vertical position through these slides
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#background-wrap',
                    offset: -1 * (headerHeight),
                    triggerHook: 'onLeave',
                    duration: '525%'
                })
                    .setPin('#background-wrap', {pushFollowers: false})
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // this pins slide 6 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide6',
                    duration: "75%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide6', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

                // this pins slide 7 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide7',
                    duration: "125%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide7', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

                // this pins slide 8 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide8',
                    duration: "75%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide8', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

                /*** END OF WATER MILL BACKGROUND **/

                // this pins slide 9 (the plain blue background) so it stays in the same place for a moment while scrolling
                // CIOS / Grant making foundations
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide9',
                    duration: "125%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide9', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));

                // slide 9 has text sliding in from the left and right
                var slideTextFromLeftTween4 = new TimelineMax()
                    .from($("#slide9").find('.from-left')[0], 0.5, {
                        css: {'left': '-50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide9").find('.from-left')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                var slideTextFromRightTween4 = new TimelineMax()
                    .from($("#slide9").find('.from-right')[0], 0.5, {
                        css: {'left': '50vw', top: 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide9").find('.from-right')[0], 0.5, {
                        css: {'left': 0, top: 0, opacity: 1},
                        ease: Linear.easeInOut
                    });
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide9",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: '75%'
                })
                    .setTween(slideTextFromLeftTween4)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide9",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: '75%'
                })
                    .setTween(slideTextFromRightTween4)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // the divider down the middle of slide 9 also slides in from the top
                $("#slide9").find('.divider-border').css('top', '50vh');
                var slideInBorder = TweenMax.to($("#slide9").find('.divider-border')[0], 0.5, {
                    css: {'top': 0},
                    ease: Linear.easeInOut
                });
                var slideOutBorder = TweenMax.to($("#slide9").find('.divider-border')[0], 0.5, {
                    css: {'top': '-50vh'},
                    ease: Linear.easeInOut
                });

                // make the divider slide in from the top when entering slide 9
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide9",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.25,
                    duration: '50%'
                })
                    .setTween(slideInBorder)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the divider slide out from the top when entering slide 10
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: "#slide10",
                    offset: -1 * (headerHeight),
                    triggerHook: 0.25,
                    duration: '50%'
                })
                    .setTween(slideOutBorder)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));
            }
            ;


            if ($('.why-choose-page').length) {
                console.log('why choose page');
                // child page
                // pin slide 1 throughout slides 2 and 3, so the heading stays still while the first 3 messages with the
                // white backgrounds scroll in and fade out
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onLeave',
                        triggerElement: '#slide1',
                        duration: "185%",
                        offset: -1 * headerHeight
                    })
                        .setPin('#slide1')
                        .addTo(controller)
                );
                // toggle the active class to fade the text with the white background to fade in/out for slide 1
                scenes.push(
                    new ScrollMagic.Scene({
                        triggerHook: 'onEnter',
                        triggerElement: '#slide1',
                        duration: "185%",
                        offset: -1 * headerHeight
                    })
                    .setClassToggle($('#slide1')[0], "active")
                    // .addIndicators({name: 'Slide 1 Class'}) // add indicators (requires plugin)
                    .addTo(controller)
                );


                // pin slide 4 for a moment so it stays on the page briefly while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide4',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                .setPin('#slide4', {pushFollowers: true})
                // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                .addTo(controller));

                // pin slide 5 for a moment so it stays on the page briefly while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide5',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                .setPin('#slide5', {pushFollowers: true})
                // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                .addTo(controller));


                // set up some animations for the text and boxes to slide in from the left and right
                var slideTextFromLeftTween = new TimelineMax().from($('#slide4').find('.titles')[0], 0.5, {
                    left: -500,
                    opacity: 0,
                    top: 0,
                    ease: Linear.easeInOut
                }).to($('#slide4').find('.titles')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                var slideBoxFromRightTween = new TimelineMax().from($('#slide4').find('.box')[0], 0.5, {
                    left: 500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide4').find('.box')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                // make the text slide in from the left when entering slide 4
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide4',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideTextFromLeftTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 4
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide4',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideBoxFromRightTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));


                // set up some animations for the text and boxes to slide in from the left and right
                var slideBoxFromLeftTween = new TimelineMax().from($('#slide5').find('.box')[0], 0.5, {
                    left: -500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide5').find('.box')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});
                var slideTextFromRightTween = new TimelineMax().from($('#slide5').find('.titles')[0], 0.5, {
                    left: 500,
                    top: 0,
                    opacity: 0,
                    ease: Linear.easeInOut
                }).to($('#slide5').find('.titles')[0], 0.5, {left: 0, top: 0, opacity: 1, ease: Linear.easeInOut});

                // make the text slide in from the right when entering slide 5
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide5',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideTextFromRightTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the left when entering slide 5
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide5',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.5,
                    duration: 0
                })
                    .setTween(slideBoxFromLeftTween)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                /*** START OF WATER MILL BACKGROUND **/

                    // this is the background which is visible during slides 6 - 8 (the water mill)
                    // slide background in
                var background = $('#background-2')[0];
                // add animations for the background to slide across and back as we scroll
                var backgroundSlideIn = TweenMax.to("#bg2-inner", 0.5, {
                    css: {'background-position-x': 0, opacity: 1, left: 0},
                    ease: Linear.easeInOut
                });
                var backgroundSlideAcross = TweenMax.to("#bg2-inner", 0.5, {
                    css: {
                        'background-position-x': '10vw', opacity: 1,
                        left: '10vw'
                    },
                    ease: Linear.easeInOut
                });
                var backgroundSlideBack = TweenMax.to("#bg2-inner", 0.5, {
                    css: {'background-position-x': 0, opacity: 1, left: 0},
                    ease: Linear.easeInOut
                });

                // set up the background to slide in when reaching the element with the background (top of slide 6)
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(backgroundSlideIn)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // slide 6 also has the text and box sliding in from the left and right
                $("#slide6").find('h2').css('left', '-25vw');
                $("#slide6").find('.box').css('left', '25vw');

                var slideTextFromLeftTween2 = new TimelineMax()
                    .from($("#slide6").find('h2')[0], 0.5, {
                        css: {'left': '-50vw', 'top': 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide6").find('h2')[0], 0.5, {
                        css: {'left': 0, 'top': 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                var slideBoxFromRightTween2 = new TimelineMax()
                    .from($("#slide6").find('.box')[0], 0.5, {
                        css: {'left': '50vw', 'top': 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide6").find('.box')[0], 0.5, {
                        css: {'left': 0, 'top': 0, opacity: 1},
                        ease: Linear.easeInOut
                    });


                // make the text slide in from the left when entering slide 6
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(slideTextFromLeftTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // make the box slide in from the right when entering slide 6
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: background,
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(slideBoxFromRightTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));


                // this pins the background for slides 6 - 8 so it stays at the same vertical position through these slides
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#background-wrap',
                    offset: -1 * (headerHeight),
                    triggerHook: 'onLeave',
                    duration: '85%'
                })
                    .setPin('#background-wrap', {pushFollowers: false})
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                // this pins slide 6 so it stays in the same place for a moment while scrolling
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: '#slide6',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide6', {pushFollowers: true})
                    // .addIndicators({name: 'Slide 3'}) // add indicators (requires plugin)
                    .addTo(controller));


                //  $("#slide8").find('h2').css('left','-25vw');

                var slideTextFromLeftTween2 = new TimelineMax()
                    .from($("#slide8").find('h2')[0], 0.5, {
                        css: {'left': '-50vw', 'top': 0, opacity: 0},
                        ease: Linear.easeInOut
                    })
                    .to($("#slide8").find('h2')[0], 0.5, {
                        css: {'left': 0, 'top': 0, opacity: 1},
                        ease: Linear.easeInOut
                    });

                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 0,
                    triggerElement: '#slide8',
                    offset: -1 * (headerHeight),
                    triggerHook: 0.75,
                    duration: 0
                })
                    .setTween(slideTextFromLeftTween2)
                    // .addIndicators() // add indicators (requires plugin)
                    .addTo(controller));

                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 0,
                    triggerElement: '#slide8',
                    duration: "200%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide8', {pushFollowers: false})
                    .addTo(controller));

                $('#slide8').find('.box:eq(0)').css('opacity', 0);
                var slide7FadeInBox = TweenMax.fromTo($('#slide8').find('.box')[0], 1,
                    {opacity: 0, left: '50vw'},
                    {opacity: 1, left: 0, ease: Circ.easeInOut});
                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 1,
                    triggerElement: '#slide8',
                    duration: 0,
                    offset: -1 * headerHeight
                })
                    .setTween(slide7FadeInBox)
                    .addTo(controller));


                $('#slide9').css('opacity', 0);
                // fade in slide 8 and fade out slide 7 when slide 8 comes in
                var slide7FadeOut = TweenMax.fromTo("#slide8", 1,
                    {opacity: 1},
                    {opacity: 0, ease: Circ.easeInOut}
                );
                var slide8FadeIn = TweenMax.fromTo($("#slide9").find('.box'), 1,
                    {opacity: 0},
                    {opacity: 1, ease: Circ.easeInOut}
                );

                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide9',
                    offset: -1 * (headerHeight),
                    triggerHook: 0,
                    duration: 0
                })
                    .setTween(slide7FadeOut)
                    .addTo(controller));
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide9',
                    offset: -1 * (headerHeight),
                    triggerHook: 0,
                    duration: 0
                })
                    .setTween(slide8FadeIn)
                    .setClassToggle("#slide9", "active") // add class toggle
                    .addTo(controller));

                // right after the slide 8 fade in, sequentially bring in the items from the bottom

                // pin slide8 and push followers

                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 0,
                    triggerElement: '#slide9',
                    duration: "100%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide9', {pushFollowers: false})
                    .addTo(controller));


                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 0,
                    triggerElement: '#slide11',
                    duration: "200%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide11', {pushFollowers: true})
                    .addTo(controller));


                $('#slide11').css('opacity', 0);
                // fade in slide 8 and fade out slide 7 when slide 8 comes in
                var slide7FadeOut = TweenMax.fromTo("#slide9", 1,
                    {opacity: 1},
                    {opacity: 0, ease: Circ.easeInOut}
                );
                var slide8FadeIn = TweenMax.fromTo("#slide11", 1,
                    {opacity: 0},
                    {opacity: 1, ease: Circ.easeInOut}
                );

                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide11',
                    offset: -1 * (headerHeight),
                    triggerHook: 0,
                    duration: 0
                })
                    .setTween(slide7FadeOut)
                    .addTo(controller));
                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide11',
                    offset: -1 * (headerHeight),
                    triggerHook: 0,
                    duration: 0
                })
                    .setTween(slide8FadeIn)
                    .setClassToggle("#slide11", "active") // add class toggle
                    .addTo(controller));

                // the added slide with the second watermill background

                scenes.push(new ScrollMagic.Scene({
                    triggerHook: 0,
                    triggerElement: '#slide12',
                    duration: "50%",
                    offset: -1 * headerHeight
                })
                    .setPin('#slide12', {pushFollowers: true})
                    .addTo(controller));

                scenes.push(new ScrollMagic.Scene({
                    triggerElement: '#slide12',
                    offset: -1 * (headerHeight),
                    triggerHook: 0,
                    duration: 0
                })
                .setClassToggle("#slide12", "active") // add class toggle
                .addTo(controller));

            }
        }
    }

    // Reset all scenes and controller
    function resetScrollMagic() {
        if (controller)
            controller.destroy('reset');
        controller = null;
        $.each(scenes, function (k, scene) {
            if (scenes[k])
                scenes[k].destroy('reset');
            scenes[k] = null;
        });
        scenes = [];
        controller = new ScrollMagic.Controller({});
    }

    if ($('.charitable-trusts-page').length) {
        $(document).on('click', '[data-action="load-inline"]', function (e) {
            e.preventDefault();
            var $this = $(this);
            var $target = $($this.data('target'));
            var urlPath = $this.attr('href');

            $target.animate({opacity: 0}, 300, function () {
                $.ajax(urlPath, {
                    success: function (data) {
                        var html = $(data).find($this.data('target')).html();
                        $target.html(html);
                        loadIcons(true);
                        setupCharitableTrustsPage(true);
                        $target.animate({opacity: 1}, 500);
                        document.title = $(data).filter('title').text();

                        $('html, body').animate({
                            scrollTop: $target.offset().top - headerHeight
                        }, 500, function () {
                            // Callback after animation
                            // Must change focus!
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                        var pageTitle = document.title;
                        document.title = pageTitle;
                        window.history.pushState({
                            "html": html,
                            "pageTitle": pageTitle,
                            "targetElement": $this.data('target')
                        }, pageTitle, urlPath);
                    }
                });
            });
        });
    }
    window.onpopstate = function (e) {
        if (e.state) {
            $(e.state.targetElement).html(e.state.html);
            document.title = e.state.pageTitle;
        } else {
            $('[data-action="load-inline"]').each(function () {
                $($(this).data('target')).html('');
            });
        }
    };
});